enum ExperianConfidence {
    VERIFIED_MATCH = 'Verified match',
}

export { ExperianConfidence };
